import Database from '../types/Database'

type NotificationType = Database.NotificationType
type NotificationMetadata = Database.NotificationMetadata

/**
 * Returns the route path for a given notification type and metadata.
 * Deterministic: same inputs always produce the same output.
 */
export function getNavigationTarget(
  type: NotificationType,
  metadata: NotificationMetadata
): string {
  switch (type) {
    case 'spot_approved':
    case 'dive_listed_nearby':
    case 'dive_cancelled':
    case 'spot_denied':
    case 'backfill_available':
      return metadata.diveId ? `/dives/${metadata.diveId}` : '/'

    case 'invite_received':
      return '/invites'

    case 'payment_window_open':
    case 'payment_expiring_soon':
      return metadata.joinRequestId ? `/payment/${metadata.joinRequestId}` : '/'

    case 'accreditation_approved':
    case 'accreditation_rejected':
      return '/account'

    case 'participant_cancelled':
      return metadata.diveId ? `/dives/${metadata.diveId}/requests` : '/'

    default:
      return '/'
  }
}
